"use strict";

exports.__esModule = true;
exports["default"] = void 0;
/**
 * Is run empty (start === end)
 *
 * @param  {Object}  run
 * @return {Object} is run empty
 */

var isEmpty = function isEmpty(run) {
  return run.start === run.end;
};

var _default = isEmpty;
exports["default"] = _default;